/**
 * @generated SignedSource<<4dbb566684deffa45eb8903e8c2b5c8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutFooter_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_item">;
  readonly " $fragmentType": "CheckoutFooter_item";
};
export type CheckoutFooter_item$key = {
  readonly " $data"?: CheckoutFooter_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFooter_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "be399ae52a8c3abc28076e6bcc58b4da";

export default node;
